import { FormGroup, FormGroupProps, FormHelperText, InputLabel } from '@mui/material'
import { FC } from 'react'

interface FormControlProps extends FormGroupProps {
  errorText?: string
  helperText?: string
  inputId: string
  label?: string
}

export const FormControl: FC<FormControlProps> = ({
  children,
  errorText,
  helperText,
  inputId,
  label,
  ...formGroupProps
}) => (
  <FormGroup {...formGroupProps}>
    <InputLabel shrink htmlFor={inputId}>
      {label}
    </InputLabel>
    {children}
    {(!!errorText || !!helperText) && !!errorText ? (
      <FormHelperText id={`${inputId}-helper`} variant={'filled'} color="error">
        {errorText}
      </FormHelperText>
    ) : (
      <FormHelperText id={`${inputId}-helper`}>{helperText}</FormHelperText>
    )}
  </FormGroup>
)
